import React from "react";

interface IProps {
  text: string;
}

export const FavorabilityDisclosure = ({ text }: IProps) => {
  return (
    <p className="text-xs text-[#6b6b6b] mt-[18px] leading-relaxed">{text}</p>
  );
};
